import script from "./HailiOrder.vue?vue&type=script&lang=ts&setup=true"
export * from "./HailiOrder.vue?vue&type=script&lang=ts&setup=true"

import "./HailiOrder.vue?vue&type=style&index=0&id=24961a50&lang=stylus&scoped=true"

import exportComponent from "/www/wwwroot/home/v-admin/node_modules/.store/vue-loader@16.8.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24961a50"]])

export default __exports__